import React, { useEffect, useState } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerTwo from "../components/DashBoardLayerTwo";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { GoogleMap, Marker, InfoWindow, useJsApiLoader ,LoadScript, useLoadScript } from "@react-google-maps/api";
import { API_GOOGLE_KEY, API_URL } from "..";
// import { useGoogleMaps } from "../GoogleMapsContext";
import MapComponentForDashboard from "./DashboardMapComponent";
import TourWidget from "./TourWidget";

import { getMessaging, getToken, onMessage } from "firebase/messaging";
import {onBackgroundMessage} from 'firebase/messaging/sw'
import firebase from 'firebase/app';
import 'firebase/messaging';
import { messaging } from "./Firebase";
import ChatBot from "../components/child/ChatBot";
import { useMapbox } from "../GoogleMapsContext";
const containerStyle = { width: "100%", height: "400px" };  // Map takes 75% width


const getStatusColor = (status) => {
  switch (status) {
    case "Waiting": return "gray";
    case "Dispatched": return "blue";
    case "Enroute": return "orange";
    case "On Scene": return "green";
    case "Being Towed": return "red";
    case "Destination Arrival": return "purple";
    case "Completed": return "black";
    default: return "gray";
  }
};

const HomePageTwo = () => {
 
  const [currentUser, setCurrentUser] = useState({});
  const [lastRefresh, setLastRefresh] = useState(null);
  const [map, setMap] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [counter,setCounter] = useState({
    
      activeAffiliates : 0,
      totalAffiliates:0,
      totalJobs:0
    
  })
  const [active, setActive] = useState(
    localStorage.getItem("activeTab") === null
    ? "company"
      : localStorage.getItem("activeTab")
  );
  const {mapboxgl} = useMapbox()
  
  const [data, setData] = useState({
    inQueueCount: 0,
    dispatchedCount: 0,
    enRouteCount: 0,
    onSceneCount: 0,
    towingCount: 0,
    completedCount: 0,
    cancelledCount: 0,
    destinationArrivals:0,
    quotesCount:0
  });
  const [drivers,setDrivers] = useState([]);
  const fetchTruckLocations = async () => {
    const user =  localStorage.getItem('user');
    const value = JSON.parse(user);
    
    try {
      const response = await fetch(
        API_URL+ '/api/truck/truck-with-location/'+value?.id,
      );
      const res = await response.json();
        setDrivers(res.data);
        
    } catch (error) {
      console.error('Error fetching truck locations:', error);
    }
  };
  const getCurrentUserIsLogin = () => {
    const user = localStorage.getItem("user");
    setCurrentUser(JSON.parse(user));
    if (user == null) {
      window.location.href = "/sign-in";
    }
  };
  useEffect(() => {
    getCurrentUserIsLogin();
    fetchTruckLocations()
    getDashboard();
    requestNotificationPermission();
  }, []);

  const getDashboard = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    let bodyContent = JSON.stringify({
      user_id: user.id,
      role: user.role,
    });
    let response;
    if (user.role == "admin" || user.role == "user") {
      response = await fetch(
        `${API_URL}/api/affiliates/dashboard`,
        {
          method: "POST",
          body: bodyContent,
          headers: headersList,
        }
      );
      let data = await response.json();
      if(response.status === 200){
        
        setCounter({
          activeAffiliates : data?.activeAffiliates,
          totalAffiliates:data?.totalAffiliates,
          totalJobs:data?.totalJobs
        });
        return;
      }
    }else{
        getDashboardCompany();
        return false;
    }
  };
  const getDashboardCompany = async () => {
    const user = JSON.parse(localStorage.getItem("user"));

    let headersList = {
      Accept: "*/*",
      "Content-Type": "application/json",
    };

    
    let response = await fetch(
      `${API_URL}/api/job/affiliate/fetch/${user.id}`,
      {
        method: "GET",
        headers: headersList,
      }
    );
    let data = await response.json();
    
    if (response.status === 200) {

      const inQueueCount  = data.data.filter((item)=>item.status === 'new' && item.status_for_job !== 'Quote' ).length;
      const dispatchedCount  = data.data.filter((item)=>item.status_for_job === 'Dispatched').length;
      const enRouteCount  = data.data.filter((item)=>item.status_for_job === 'Enroute').length;
      const onSceneCount  = data.data.filter((item)=>item.status_for_job === 'On Scene').length;
      const towingCount  = data.data.filter((item)=>item.status_for_job === 'Towing').length;
      const completedCount  = data.data.filter((item)=>item.status_for_job === 'Completed').length;
      const destinationCount  = data.data.filter((item)=>item.status_for_job === 'Destination Arrival').length;
      const cancelledCount = data.data.filter((item)=>item.status_for_job === 'cancelled').length
      const quotesCount = data.data.filter((item)=>item.status_for_job === 'Quote').length
     
      setLastRefresh(formatDateTime())
      setData({
        inQueueCount: inQueueCount,
        dispatchedCount :dispatchedCount,
        enRouteCount :enRouteCount,
        onSceneCount :onSceneCount,
        towingCount :towingCount,
        completedCount :completedCount,
        cancelledCount :cancelledCount,
        destinationArrivals:destinationCount,
        quotesCount: quotesCount

      });
    }
  };


 

  const fetchFrom = async () => {
    const user = JSON.parse();
  };
  useEffect(() => {
      getDashboardCompany();
  }, []);

  const onMarkerClick = (driver) => {
    setSelectedDriver(driver);
  };
  
 
   function formatDateTime(dateInput = new Date()) {
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    
    // Array of month names (short form)
    const monthNames = [
      "Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    
    // Extract components
    const day = String(date.getDate()).padStart(2, "0");
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    
    // Convert to 12-hour format
    hours = hours % 12 || 12;
  
    // Return formatted string
    return `${day} ${month} ${year} ${hours}:${minutes} ${ampm}`;
  }
  const requestNotificationPermission = async () => {
    
    try {
      const permission = await Notification.requestPermission();
      if (permission === 'granted') {
        const token = await getToken(messaging, { vapidKey: "BA_PEQgd7oIEGs6P7eJ7JtQgJB9VtNRtyxpBLrejA8TjSvHlgMb9Pyitz9gHEbsb6fW8-2eMx56YsZO9sZw8nGQ" });
        
        postTokenToApi(token);
      } else if (permission === 'denied') {
        console.log('Notification permission denied');
        // Handle denied permission gracefully
      } else {
        console.log('Notification permission dismissed');
      }
    } catch (error) {
      console.error('Error requesting permission:', error);
    }
  };  
  const postTokenToApi = async (token)=>{
     try {
      const user = localStorage.getItem('user');
      const json  = JSON.parse(user);
      let url;
      if(json?.role == 'owner'){
       url = `${API_URL}/api/affiliates/send-notification-token/${json.id}/owner`
      }else{
        url = `${API_URL}/api/affiliates/send-notification-token/${json.id}/admin`
      }
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          "Accept": "*/*",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          token: token,
          status: "true"
        })
      });
      if(response.status === 200){
        
      }
     } catch (error) {
      
     }
  }
  // if(!isLoaded) return  <p>Loading...</p>
  return (
    <>
      {/* MasterLayout */}
      
      <MasterLayout>
        {/* Breadcrumb */}
        {/* <Breadcrumb /> */}
       
        {currentUser.role === "owner" ? (
          <>
          <section className="row gy-4">
            <div className="col-md-12">
          
            <h6 style={{margin: 0}}>Dispatch Overview</h6>
            <p>Last Refresh: {lastRefresh}</p>
            </div>
            <div className="col-xxl-12">
              <div className=" p-0 overflow-hidden position-relative radius-12 h-100">
                <div className=" p-4 pt-0">
                <div className="row" style={{ rowGap: 10 }}>
                          <div className="col-md-2">
                            <div className="card p-3 shadow-none border bg-gradient-start-9 h-100">
                              <Link to={"/leads/in-queue"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                          <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            In-Queue
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.inQueueCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-9">
                              <Link to={"/leads/dispatched"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="mingcute:user-follow-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Dispatched
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.dispatchedCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-2">
                              <Link to={"/leads/enroute"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            En Route
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.enRouteCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-9">
                              <Link to={"/leads/onscene"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            On Scene
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.onSceneCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className=" card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-9">
                              <Link to={"/leads/towing"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Towing
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.towingCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className=" card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-9">
                              <Link to={"/leads/destination-arrival"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Destination
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.destinationArrivals || 0 }
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2 ">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light bg-gradient-end-9">
                              <Link to={"/leads/completed"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Completed
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.completedCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-9">
                              <Link to={"/leads/cancelled"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Cancelled
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.cancelledCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-9">
                              <Link to={"/leads/quotes"}>
                                <div className="">
                                  <div className="card-body p-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                      <div className="d-flex align-items-center gap-2">
                                        <span className="mb-0 w-40-px h-40-px bg-secondary text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                          <Icon
                                            icon="iconamoon:discount-fill"
                                            className="icon"
                                          />
                                        </span>
                                        <div>
                                          <span className="mb-2 fw-medium text-secondary-light text-sm">
                                            Quotes
                                          </span>
                                          <h6 className="fw-semibold">
                                            {data?.quotesCount || 0}
                                          </h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          </div>
                        </div>
                </div>
              </div>
            </div>
      
          </section>
          <section className="row gy-4 mt-4" style={containerStyle}>
               <div className="col-md-12">
                <h6 className="mb-3">Fleets Location</h6>
                {
                  drivers && 
                  (
                    drivers?.length  === 0 ? null :
                    <MapComponentForDashboard trucks={drivers}/> 
                  )
                }
               </div>
              </section>
              
          </>
        ) : null}
        {currentUser.role === "admin" || currentUser.role === "user" ? (
           <div className="col-md-12">
           <div className="row" style={{columnGap:10}}>
               <div className="col-md-3 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-1">
                <Link to={'/sign-up-user/all'}>
                   <div className="">
                       <div className="card-body p-0">
                           <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                               <div className="d-flex align-items-center gap-2">
                                   <span className="mb-0 w-48-px h-48-px bg-primary-600 flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0">
                                       <Icon
                                           icon="mingcute:user-follow-fill"
                                           className="icon"
                                       />
                                   </span>
                                   <div>
                                       <span className="mb-2 fw-medium text-secondary-light text-sm">
                                           Total Affiliates
                                       </span>
                                       <h6 className="fw-semibold">{counter?.totalAffiliates}</h6>
                                   </div>
                               </div>
                            

                           </div>
                           
                       </div>
                   </div>
                </Link>
               </div>
               <div className="col-md-3 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-2">
                  <Link to={'/sign-up-user/active'}>
                   <div className="">
                       <div className="card-body p-0">
                           <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                               <div className="d-flex align-items-center gap-2">
                                   <span className="mb-0 w-48-px h-48-px bg-success-main flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6">
                                       <Icon
                                           icon="mingcute:user-follow-fill"
                                           className="icon"
                                       />
                                   </span>
                                   <div>
                                       <span className="mb-2 fw-medium text-secondary-light text-sm">
                                           Active Affiliates
                                       </span>
                                       <h6 className="fw-semibold">{counter?.activeAffiliates}</h6>
                                   </div>
                               </div>
                              
                           </div>
                         
                       </div>
                   </div>
                   </Link>
               </div>
               <div className="col-md-3 card p-3 shadow-2 radius-8 border input-form-light h-100 bg-gradient-end-3">
                   <Link to={'/leads'}>
                   <div className="">
                       <div className="card-body p-0">
                           <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                               <div className="d-flex align-items-center gap-2">
                                   <span className="mb-0 w-48-px h-48-px bg-yellow text-white flex-shrink-0 d-flex justify-content-center align-items-center rounded-circle h6">
                                       <Icon
                                           icon="iconamoon:discount-fill"
                                           className="icon"
                                       />
                                   </span>
                                   <div>
                                       <span className="mb-2 fw-medium text-secondary-light text-sm">
                                           Total Jobs
                                       </span>
                                       <h6 className="fw-semibold">{counter?.totalJobs}</h6>
                                   </div>
                               </div>
                            
                           </div>
                         
                       </div>
                   </div></Link>
               </div>
            
           </div>
       </div>
        ) : null}
        <ChatBot affiliateId={currentUser.id}/>
      </MasterLayout>
    
    </>
  );
};

export default HomePageTwo;
